export enum StreamMode {
    MUSIC_CHANNEL = "MUSIC_CHANNEL",
    CALENDAR = "CALENDAR"
}